import * as Actions from './actions'
import {initialState} from '../store/initialState'

export const SearchKeywordsReducer = (state = initialState.searchKeywords, action) =>{
    
    switch(action.type){
        case Actions.UPDATE_SEARCH_KEYWORDS:
            //console.trace(action.payload);
            return{
                ...state,
                text:action.payload//新しい配列として更新する。コンポーネント側で変更を検知するため。
            };
        default:
            return state
    }
}